import { AlertTriangle, RotateCw } from "lucide-react";
import { Component, type ErrorInfo, type PropsWithChildren } from "react";

interface State {
  error: Error | null;
  correlationId: string | null;
}

export class AppErrorBoundary extends Component<PropsWithChildren, State> {
  state: State = { error: null, correlationId: null };

  static getDerivedStateFromError(error: Error): State {
    return { error, correlationId: crypto.randomUUID() };
  }

  componentDidCatch(error: Error, info: ErrorInfo) {
    console.error("Calcme 3D UI boundary", {
      name: error.name,
      message: error.message,
      componentStack: info.componentStack,
      correlationId: this.state.correlationId,
    });
  }

  render() {
    if (!this.state.error) return this.props.children;
    return (
      <main className="fatal-error">
        <AlertTriangle size={40} />
        <h1>Esta tela encontrou um problema</h1>
        <p>O projeto e o rascunho permanecem preservados. Recarregue a interface para reconstruir a tela.</p>
        <button className="button button--primary" onClick={() => window.location.reload()}><RotateCw size={17} /> Recarregar</button>
        <small>Referência {this.state.correlationId}</small>
      </main>
    );
  }
}
